import { Component, inject, OnInit, viewChild } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { UserService } from '../../core/services/user/user.service';
import { HeaderComponent } from '../../core/shared/layout/header/header.component';
import { FooterComponent } from '../../core/shared/layout/footer/footer.component';
import { BonusShopTabComponent } from './bonus-shop-tab/bonus-shop-tab.component';
import { TabsComponent } from '../../core/shared/modules/tabs/tabs.component';
import { TabItemComponent } from '../../core/shared/modules/tabs/tab-item.component';
import { TranslatePipe } from '../../core/shared/translation/translate.pipe';
import { BottomNavigationComponent } from '../../core/shared/layout/bottom-navigation/bottom-navigation.component';
import { BonusStoreService } from '../../core/services/bonus-store.service';
import { SideNavComponent } from '../../core/shared/layout/side-nav/side-nav.component';
import { BonusShopEnum } from './bonus-shop.types';
import { EasterService } from '../promo/easter/easter.service';
import { EventEnum } from '../promo/base-promo';

@Component({
  selector: 'app-bonus-shop',
  templateUrl: './bonus-shop.component.html',
  styleUrls: ['./bonus-shop.component.scss'],
  imports: [
    HeaderComponent,
    SideNavComponent,
    BottomNavigationComponent,
    FooterComponent,
    AsyncPipe,
    TranslatePipe,
    TabItemComponent,
    TabsComponent,
    BonusShopTabComponent,
  ],
})
export class BonusShopComponent implements OnInit {
  user = inject(UserService);
  bonusStore = inject(BonusStoreService);
  easter = inject(EasterService);

  readonly tabs = viewChild<TabsComponent>('tabs');
  readonly coinsTab = viewChild<TabItemComponent>('coinsTab');
  readonly cashTab = viewChild<TabItemComponent>('cashTab');

  public activeTab: any;


  ngOnInit() {
  }

  public onSelectTab(e) {
    this.activeTab = e;
  }

  protected readonly BONUS_SHOP_TYPE = BonusShopEnum;
  protected readonly EventType = EventEnum;
}
